// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-5575d025]{font-family:Vazir,serif!important;white-space:break-spaces;overflow:hidden}.link-tag[data-v-5575d025],.link-tag .v-icon[data-v-5575d025]{color:#0985d2!important;cursor:pointer}.link-tag[data-v-5575d025]:hover,.link-tag:hover .v-icon[data-v-5575d025]{color:#33a9f1!important}", ""]);
// Exports
module.exports = exports;
